import React from "react";
import "./searchItems.css";

import Searchbar from "../../Searchbar";
import { useSelector } from "react-redux";
import Assessment from "../../../assets/icons/assessments";
import Back from "../../../assets/icons/back";
import { useDisableBodyScroll } from "../../../hooks/useDisableBodyScroll";

export default function SearchItems({ searchItemsActive, setSearchItemsActive }) {
  const { activityTypes } = useSelector((state) => state.activityTypes);
  useDisableBodyScroll(searchItemsActive);

  return (
    <div className="activity_types_list_container">
      <div className="menu_header">
        <div onClick={() => setSearchItemsActive(false)} className="close_menu_btn">
          <Back />
        </div>

        <div className="searchbar_container">
          <Searchbar iconColor="black" placeholder="Search any activity" />
        </div>
      </div>

      <div className="search_items">
        {activityTypes.map((type) => {
          return (
            <div key={type.id} className="search_items__item d-flex">
              <div className="search_items__img_container d-flex">
                <Assessment fill="#474747" />
                {/* <img src='assets/icons/activityCategories/assessment.svg' /> */}
              </div>
              <div className="search_items__name">
                <p> {type.name} </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
